<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">      
      <div class="pledge-box1">  
        <!-- filter -->
        <div class="pledge-box1-top"> 
          <div class="Quarterly-Report" style="float: left;">
            <div class="head-title" @click.stop="showDateDropmemu($event)">
              {{ datetype_name }}
              <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
            </div>
            <ul class="menu-lanmu" v-show="dateDropmenu">  
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(1)">一个月</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(2)">一个季度</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(3)">半年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(4)">去年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(5)">今年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(6)">一年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(7)">两年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(8)">三年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(9)">五年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(10)">十年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(98)">全部</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(99)">自定义</a></li>
            </ul>
          </div> 

          <a class="cop-search-bot" href="javascript:;" @click="getQuotesChangeList()">查询</a>
          <div class="cop-date" v-if="datetype == 99">
            <p class="time"> 
              <span class="l">
                <date-picker :time.sync="startdate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
              至 
              <span class="r">
                <date-picker :time.sync="enddate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
            </p>
          </div>
        </div><!-- /filter -->

        <div class="pledge-box1">  
          <div class="Single-list-main">
            <div class="relation-chart gujia-chart-wrap">
              <div class="gujia-chart" style="width:100%; height:400px"></div>
            </div>
          </div>    
        </div>  
      </div>
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import wxshareMix from '../../common/wxshareMix'
  import myDatepicker from '../../helper/datepicker.vue'

  export default {
    name: 'StockTop',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    components: {
      'date-picker': myDatepicker,
    },
    data () {
      return {
        quotesChangeLists: [],
        performanceNoticeLists: [],
        perSort: {
          type: '',
          ksrq: 1,
          jsrq: 1,
          jllfd: 1,
          bnjll: 1,
          snjll: 1,
          ggrq: 1,
        },
        datepicker: {
          option: {
            type: 'day',
            week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            format: 'YYYY-MM-DD',
            placeholder: '',
            inputStyle: {
              'display': 'inline-block',
              'width': '120px',
              'padding': '4px 6px',
              'line-height': '22px',
              'font-size': '16px',
              'box-shadow': '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
              'border-radius': '5px',
              'color': 'rgb(95, 95, 95)'
            },
            color: {
              header: '#00736a',
              headerText: '#ffffff'
            },
            buttons: {
              clear: '清空',
              today: '今天',
              ok: '确定',
              cancel: '取消'
            },
            overlayOpacity: 0.5, // 0.5 as default
            dismissible: true // as true as default
          },
        },
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.changeDateType(7);
          this.datetype_name = '两年';
          this.getQuotesChangeList();
        }

      }
    },
    methods: {
      getQuotesChangeList: function() {
        let query = {};
        query.companycode = this.companycode;
        query.stype = parseInt(this.stype);
        query.startdate = this.startdate;
        query.enddate = this.enddate;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/historicalquotes'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.quotesChangeLists = response.data;

            if (response.data.length > 0) {
              let data = response.data;
              let newD = [];
              let arr = [];

              for (let item of data) {
                arr = [];
                arr.push(item.d);
                arr.push(item.open);
                arr.push(item.close);
                arr.push(item.low);
                arr.push(item.high);
                arr.push(item.volume);

                newD.push(arr);
              }

              // 绘图
              let divClass = '.gujia-chart-wrap';
              let canvasClass = '.gujia-chart';
              this.echartKLine(newD, divClass, canvasClass);
            }
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }

  .Single-list-main {
    width: 100%;
    box-shadow: none;
    padding: 0;
  }
  .gujia-chart-wrap {
    border: none !important;
  }
</style>


/** WEBPACK FOOTER **
 ** TradeInfo.vue?4faf995d
 **/